module.exports = __webpack_public_path__ + "static/img/logo.7cc1f1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/logo.png
// module id = NwV7
// module chunks = 1